import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './BinyanSelector.css';

function BinyanSelector() {
  const navigate = useNavigate();
  const { grade } = useParams();

  const binyans = [
    {
      id: 'binyan1',
      name: 'בניין 1 - فَعَلَ',
      arabicName: 'فَعَلَ',
      icon: '1️⃣',
      description: '8 משחקים',
      color: '#4CAF50'
    },
    {
      id: 'binyan2',
      name: 'בניין 2 - فَعَّلَ',
      arabicName: 'فَعَّلَ',
      icon: '2️⃣',
      description: '2 משחקים',
      color: '#2196F3'
    },
    {
      id: 'binyan3',
      name: 'בניין 3 - فَاعَلَ',
      arabicName: 'فَاعَلَ',
      icon: '3️⃣',
      description: '2 משחקים',
      color: '#9C27B0'
    },
    {
      id: 'binyan4',
      name: 'בניין 4 - أَفْعَلَ',
      arabicName: 'أَفْعَلَ',
      icon: '4️⃣',
      description: '2 משחקים',
      color: '#FF5722'
    },
    {
      id: 'binyan5',
      name: 'בניין 5 - تَفَعَّلَ',
      arabicName: 'تَفَعَّلَ',
      icon: '5️⃣',
      description: '2 משחקים',
      color: '#00BCD4'
    },
    {
      id: 'binyan6',
      name: 'בניין 6 - تَفَاعَلَ',
      arabicName: 'تَفَاعَلَ',
      icon: '6️⃣',
      description: '2 משחקים',
      color: '#8BC34A'
    },
    {
      id: 'binyan7',
      name: 'בניין 7 - إِنْفَعَلَ',
      arabicName: 'إِنْفَعَلَ',
      icon: '7️⃣',
      description: '2 משחקים',
      color: '#FFC107'
    },
    {
      id: 'binyan8',
      name: 'בניין 8 - إِفْتَعَلَ',
      arabicName: 'إِفْتَعَلَ',
      icon: '8️⃣',
      description: '2 משחקים',
      color: '#607D8B'
    },
    {
      id: 'binyan10',
      name: 'בניין 10 - إِسْتَفْعَلَ',
      arabicName: 'إِسْتَفْعَلَ',
      icon: '🔟',
      description: '2 משחקים',
      color: '#795548'
    },
    {
      id: 'all-binyans',
      name: 'כל הבניינים',
      arabicName: 'גזרת השלמים',
      icon: '🌟',
      description: '2 משחקים',
      color: '#E91E63'
    }
  ];

  const gradeNames = {
    'grade10': 'שכבה י׳',
    'grade11': 'שכבה י״א',
    'grade12': 'שכבה י״ב'
  };

  const handleBinyanClick = (binyanId) => {
    navigate(`/grade/${grade}/verbs/binyan/${binyanId}`);
  };

  const handleBackToSubjects = () => {
    navigate(`/grade/${grade}`);
  };

  return (
    <div className="binyan-selector">
      <div className="binyan-selector-container">
        <div className="header-with-back">
          <button onClick={handleBackToSubjects} className="back-to-grade-button" style={{ top: '-32px' }}>
            חזרה לבחירת נושא לימוד ↩
          </button>
          <h2>{gradeNames[grade]} - בחירת בניין</h2>
        </div>

        <p className="binyan-selector-subtitle">בחר את הבניין שברצונך לתרגל</p>

        <div className="binyans-grid">
          {binyans.map((binyan, index) => {
            const displayNumber = binyan.id === 'all-binyans' ? '★' : 
                                binyan.id === 'binyan10' ? '10' : 
                                (index + 1).toString();
            
            return (
              <div
                key={binyan.id}
                className="cloud-card"
                style={{ '--drop-seed': index }}
              >
                <div
                  className="cloud-shape"
                  onClick={() => handleBinyanClick(binyan.id)}
                >
                  {grade === 'grade11' && (index === 0 || index === 6) && (
                    <div className="drop-stream">
                      <div className="drop-bubble drop-eye">👀</div>
                      <div className="drop-bubble drop-clock">⏰</div>
                      <div className="drop-bubble drop-micro">🔬</div>
                    </div>
                  )}
                  <div
                    className="cloud-number"
                    onClick={() => handleBinyanClick(binyan.id)}
                  >
                    <span className="number-text">{displayNumber}</span>
                  </div>
                  <div className="cloud-emoji">
                    ☁️
                  </div>
                  <div className="cloud-content">
                    <h3 className="cloud-binyan-name">{binyan.name}</h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default BinyanSelector;


